import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { Link as Component } from './components/link';
import type { ILinkDependencies, ILinkProps } from './models';
import styles from './styles/styles.css';

export const Link = createWidget<ILinkDependencies, ILinkProps>({ styles })(Component);
